import * as React from "react"
import { useEffect }  from "react";
import { Grid } from "@mui/material";

import { isSystemBusy } from "@signals";
import { PRODUCT_PAGE_ROUTES } from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import { productPageImageDetailsIsEmpty, clearProductPageImageDetailSignal } from "./@signals";
import ProductPagesImagesDetailsFilters from "./Filters";
import ProductPageImageDetailsTable from "./Table";
import ProductPagesImagesDetailModal from "./ModalImages";


export default function ProductPageImageDetailsPage() {

    useEffect(() => {
        return () => clearProductPageImageDetailSignal()
    }, []);

    return <PageWrapper
        tourPageKey="productPageImageDetails"
        head={`DIP Insight | ${PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_TITLE}`}
        title={PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_TITLE}
        subtitle={PRODUCT_PAGE_ROUTES.IMAGE_DETAILS_SUBTITLE}
        isEmpty={productPageImageDetailsIsEmpty.value}
        filters={<ProductPagesImagesDetailsFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="pp-image-details-table" height={350} />
                <ProductPageImageDetailsTable />
            </Grid>
            <ProductPagesImagesDetailModal />
        </Grid>

    </PageWrapper>
}